import React from "react";
import { motion } from "framer-motion";
import { AlertTriangleIcon, StarIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { CountdownTimer } from "./CountdownTimer";
import { IMAGES, PRICE, PRICE_ANCHOR } from "../src/config";
export function Hero() {
  return <section className="relative w-full overflow-hidden" data-id="element-130" data-mp="4m8mecr76rkx">
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: `url(${IMAGES.heroBg})`
    }} aria-hidden="true" data-id="element-131" data-mp="4jm69oq8r3r3" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a1f]/80 via-[#0a0a1f]/85 to-[#0a0a1f]" aria-hidden="true" data-id="element-132" data-mp="xbfi73z9p32h" />

      <div className="relative mx-auto max-w-5xl px-4 pb-16 pt-12 text-center sm:px-6 sm:pt-16" data-id="element-133" data-mp="s9giq56neqat">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mx-auto mb-6 inline-flex items-center gap-2 rounded-full border border-red-500/40 bg-red-500/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-red-300" data-id="element-134" data-mp="nbyj55eitnfh">
          <AlertTriangleIcon className="h-4 w-4" data-id="element-135" data-mp="3o85cdefo0765" />
          Solo para freelancers, agencias y emprendedores de LATAM
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55,
        delay: 0.05
      }} className="font-display text-3xl font-extrabold leading-tight text-white sm:text-5xl md:text-6xl" data-id="element-136" data-mp="399tdr28qeocc">
          ¿Tu inglés es el{" "}
          <span className="text-violet-400" data-id="element-137" data-mp="35a2gqgsm3bzd">techo de tus ingresos?</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55,
        delay: 0.12
      }} className="mx-auto mt-5 max-w-2xl text-base text-slate-300 sm:text-lg" data-id="element-138" data-mp="2qleqmq1jbugt">
          En el mercado hispano peleas por migajas. En USA cobras{" "}
          <span className="font-bold text-white" data-id="element-139" data-mp="2lmuz8a469qh2">10 veces más</span> por el mismo
          trabajo. Aprende a usar la IA para sonar como un nativo y facturar en
          dólares —{" "}
          <span className="font-semibold text-emerald-400" data-id="element-140" data-mp="na08qxnyt1dn">sin hablar inglés perfecto.</span>
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="mx-auto mt-8 max-w-md" data-id="element-141" data-mp="ia5jsznr2lv8">
          <img src={IMAGES.ebook} alt="Ebook The Bilingual Sales Machine" className="mx-auto w-52 drop-shadow-[0_20px_45px_rgba(139,92,246,0.4)] sm:w-64" data-id="element-142" data-mp="161t0korasgjs" />
        </motion.div>

        <div className="mt-8 flex flex-col items-center gap-4" data-id="element-143" data-mp="x1w8ed5p8zjz">
          <div className="flex items-center gap-3 text-lg" data-id="element-144" data-mp="x3h0zx8ge8f7">
            <span className="text-slate-500 line-through" data-id="element-145" data-mp="3ltqghnsxvfys">{PRICE_ANCHOR}</span>
            <span className="font-display text-4xl font-extrabold text-emerald-400" data-id="element-146" data-mp="3hr3q7rbx233p">
              {PRICE}
            </span>
          </div>

          <div className="flex items-center gap-2 rounded-xl border border-white/10 bg-white/5 px-4 py-3" data-id="element-147" data-mp="1x783xkq1jlsj">
            <span className="text-xs uppercase tracking-wider text-slate-400" data-id="element-148" data-mp="218jwnz47on4y">
              La oferta expira en
            </span>
            <CountdownTimer minutes={15} data-id="element-149" data-mp="2b196kpk45sy6" />
          </div>

          <CTAButton className="mt-2" subtext="Acceso inmediato · Garantía incondicional de 7 días" data-id="element-150" data-mp="2b2sm2dxy3zyw" />

          <div className="mt-2 flex items-center justify-center gap-1 text-sm text-slate-300" data-id="element-151" data-mp="2kyduouxiryhm">
            <div className="flex text-amber-400" data-id="element-152" data-mp="2p0qqormgsi17">
              {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" data-id="element-153" data-mp="2u03i7poa6da4" data-mpi={i} />)}
            </div>
            <span className="ml-1" data-id="element-154" data-mp="un99rngkejf5">+2.400 latinos ya facturan en USD</span>
          </div>
        </div>
      </div>
    </section>;
}